import React from "react";
import { DPFileUpload } from "Components/DP";
import { ButtonProps } from "@material-ui/core";
import { useApolloClient } from "@apollo/client";
import { DocumentNode } from "graphql";
import {
  UploadMutation,
  UploadMutationTypes,
  UploadMutationResTypes,
  Mutations,
  UploadResponse,
} from "Shared/types/UploadButton";
import "react-toastify/dist/ReactToastify.min.css";
import Formatting from "Modules/DataExchange/Formatting";
import { successToast } from "Modules/DPToast";
import { handleValidationErrors } from "Modules/HandleValidationErrors";

type Props = {
  refetch: { query: DocumentNode }[];
  mutationName: UploadMutationTypes;
  mutationResponse: UploadMutationResTypes;
  uploadMutation: Mutations;
  ButtonProps?: ButtonProps;
};
const UploadButton = ({
  uploadMutation,
  refetch,
  mutationName,
  mutationResponse,
  ButtonProps,
}: Props) => {
  type eventProps = {
    target: {
      files: File[];
    };
  };

  const apolloClient = useApolloClient();
  const { acceptTypes } = Formatting.getFileTypes(mutationResponse);

  const handleFileUpload = async ({
    target: {
      files: [file],
    },
  }: eventProps) => {
    try {
      const response = await uploadMutation({
        variables: { [mutationName]: { attachment: file } },
        refetch,
      } as UploadMutation);
      const { data } = response as UploadResponse;
      successToast(data[mutationResponse].message);
      apolloClient.resetStore();
    } catch (err) {
      handleValidationErrors(err);
    }
  };

  return (
    <DPFileUpload
      accept={acceptTypes}
      onChange={handleFileUpload}
      {...ButtonProps}
    >
      Upload
    </DPFileUpload>
  );
};
export default UploadButton;
